function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#fff;stroke-linecap:round;stroke-linejoin:round;stroke-width:10px;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Layer_1-2",
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("circle", {
  className: "cls-1",
  cx: 343.22,
  cy: 343.22,
  r: 198.1,
  transform: "translate(-142.17 343.22) rotate(-45)"
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-1",
  x1: 343.22,
  y1: 72.5,
  x2: 343.22,
  y2: 1.5
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-1",
  x1: 343.22,
  y1: 684.95,
  x2: 343.22,
  y2: 613.95
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-1",
  x1: 151.79,
  y1: 151.79,
  x2: 101.59,
  y2: 101.59
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-1",
  x1: 584.86,
  y1: 584.86,
  x2: 534.66,
  y2: 534.66
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-1",
  x1: 534.66,
  y1: 151.79,
  x2: 584.86,
  y2: 101.59
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-1",
  x1: 101.59,
  y1: 584.86,
  x2: 151.79,
  y2: 534.66
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-1",
  x1: 613.95,
  y1: 343.23,
  x2: 684.95,
  y2: 343.23
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-1",
  x1: 1.5,
  y1: 343.23,
  x2: 72.5,
  y2: 343.23
})));

const SvgDay = (_ref) => {
  let svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 686.45 686.45",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDay, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/day.0bd3c2c3.svg";
export { ForwardRef as ReactComponent };